import {
  fieldApps,
  fieldTypes,
  typesConf,
  HEADING,
  BODY,
  getAppConfigurator,
} from '@infotech/view-config'
import {
  nest,
  withProps,
} from 'recompose'
import map from 'lodash/map'
import get from 'lodash/get'
import pickBy from 'lodash/pickBy'
import keyBy from 'lodash/keyBy'
import {
  Text,
  WithTitle,
  InputHelper,
  formFieldAdapter,
  withDebounce,
  DateFormatter,
  DateRange,
} from '@infotech/base-components'
import {
  textSearchFilters,
} from '@infotech/filters'
import { createGetColumnsConf } from '@infotech/crud'
import UIKitInput from '@infotech/uikit-input'

import dateISOStringFilter from './components/dateISOStringFilter'
import Download from './components/Download'

const DebouncedUIKitInput = formFieldAdapter(
  nest(
    InputHelper,
    withDebounce(UIKitInput),
  ),
)

export const fieldsConf = {
  id: {
    type: fieldTypes.TEXT,
    name: `id`,
    apps: {
      [fieldApps.COLUMN]: {
        name    : `id`,
        sortable: true,
        width   : 70,
      },
      [fieldApps.VIEW]: {
        place    : HEADING,
        component: nest(WithTitle, Text),
        title    : `id`,
      },
      [fieldApps.FILTER]: {
        title    : `id`,
        component: DebouncedUIKitInput,
      },
    },
  },
  createdAt: {
    type: fieldTypes.TEXT,
    name: `createdAt`,
    apps: {
      [fieldApps.VIEW]: {
        title    : `request`,
        place    : HEADING,
        component: nest(WithTitle, DateFormatter),
      },
      [fieldApps.COLUMN]: {
        name     : `createdAt`,
        sortable : true,
        formatter: withProps({ format: `DD.MM.YYYY HH:mm:ss.SSS` })(DateFormatter),
        width    : 180,
      },
      [fieldApps.FILTER]: {
        title        : `createdAt`,
        component    : DateRange,
        parseValue   : dateISOStringFilter.parseValue,
        valueToFilter: dateISOStringFilter.valueToFilter,
      },
    },
  },
  request: {
    type: fieldTypes.TEXT,
    name: `request`,
    apps: {
      [fieldApps.COLUMN]: {
        name     : `request`,
        formatter: Download,
        width    : 150,
      },
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, Download),
        title    : `request`,
      },
      [fieldApps.FILTER]: {
        title        : `request`,
        component    : DebouncedUIKitInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  response: {
    type: fieldTypes.TEXT,
    name: `response`,
    apps: {
      [fieldApps.COLUMN]: {
        name     : `response`,
        formatter: Download,
        width    : 150,
      },
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, Download),
        title    : `response`,
      },
      [fieldApps.FILTER]: {
        title        : `response`,
        component    : DebouncedUIKitInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  error: {
    type: fieldTypes.TEXT,
    name: `error`,
    apps: {
      [fieldApps.COLUMN]: {
        name     : `error`,
        formatter: Download,
        width    : 150,
      },
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, Download),
        title    : `error`,
      },
      [fieldApps.FILTER]: {
        title        : `error`,
        component    : DebouncedUIKitInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  category: {
    type: fieldTypes.TEXT,
    name: `category`,
    apps: {
      [fieldApps.COLUMN]: {
        name    : `category`,
        sortable: true,
        width   : 150,
      },
      [fieldApps.VIEW]: {
        place    : HEADING,
        component: nest(WithTitle, Text),
        title    : `category`,
      },
      [fieldApps.FILTER]: {
        title        : `category`,
        component    : DebouncedUIKitInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  description: {
    type: fieldTypes.TEXT,
    name: `description`,
    apps: {
      [fieldApps.COLUMN]: {
        name    : `description`,
        sortable: true,
        minWidth: 150,
      },
      [fieldApps.VIEW]: {
        place    : HEADING,
        component: nest(WithTitle, Text),
        title    : `description`,
      },
      [fieldApps.FILTER]: {
        title        : `description`,
        component    : DebouncedUIKitInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
    },
  },
  serviceId: {
    type: fieldTypes.TEXT,
    name: `serviceId`,
    apps: {
      [fieldApps.FILTER]: {
        title    : `serviceId`,
        component: DebouncedUIKitInput,
        disabled : true,
      },
    },
  },
}

export const defaultColumnsList = [
  `id`,
  `createdAt`,
  `request`,
  `response`,
  `error`,
  `category`,
  `description`,
]

export const defaultFormList = [
]

export const defaultFormListEdit = [
]

export const defaultViewList = [
  `id`,
  `createdAt`,
  `request`,
  `response`,
  `error`,
  `category`,
  `description`,
]

export const defaultFilterList = [
  `serviceId`,
  `id`,
  `createdAt`,
  `request`,
  `response`,
  `error`,
  `category`,
  `description`,
]

export const allColumnsList = map(
  pickBy(fieldsConf, (field) => get(field, [`apps`, fieldApps.COLUMN])),
  ({ name }, key) => ({
    key,
    name,
  }),
)

export const issuesAppsConf = (fieldsConfig) => getAppConfigurator(fieldsConfig, typesConf)

export const getColumnsConf = (
  fieldsList = defaultColumnsList, fieldsConfig = fieldsConf,
) => createGetColumnsConf(issuesAppsConf(fieldsConfig)(fieldApps.COLUMN), fieldsList)

export const getViewConfig = (
  fieldsList = defaultViewList, fieldsConfig = fieldsConf,
) => fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.VIEW))

export const getFilterConfig = (
  fieldsList = defaultFilterList, fieldsConfig = fieldsConf,
) => keyBy(fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.FILTER)), `key`)

export const getFormConfig = (
  fieldsList = defaultFormList, fieldsConfig = fieldsConf,
) => keyBy(fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.FORM)), `key`)

export const configWithData = (issue, config) => config.map((field) => ({
  ...field,
  data: issue[field.key],
}))
